import React, { useRef, useState } from "react";
import DateSelector from "../commonComponents/inputComponents/DateSelector";
import InputBox from "../commonComponents/inputComponents/InputBox";
import "./loginSignupPage.css";

import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";

import { useAuth } from "../../contexts/AuthContext";
import { useNavigate } from "react-router-dom";

import { toast } from "react-toastify";

import Loader from "../commonComponents/Loader/Loader";

import "react-toastify/dist/ReactToastify.css";

export default function SignupPage() {
  const [isLoading, setIsLoading] = useState(false);

  const { signup } = useAuth();
  const navigate = useNavigate();

  const nameRef = useRef();
  const phoneRef = useRef();
  const dayRef = useRef();
  const monthRef = useRef();
  const yearRef = useRef();
  const passRef = useRef();
  const passConfRef = useRef();

  async function handleSubmit(e) {
    e.preventDefault();
    setIsLoading(true);

    const Name = nameRef.current.value;
    const Phone = phoneRef.current.value;
    const Year = yearRef.current.value;
    const Month = monthRef.current.value;
    const Day = dayRef.current.value;
    const Password = passRef.current.value;
    const PasswordConfirm = passConfRef.current.value;

    if (
      !Name ||
      !Phone ||
      !Year ||
      !Month ||
      !Day ||
      !Password ||
      !PasswordConfirm
    ) {
      setIsLoading(false);
      return toast.error("لطفا اطلاعات را وارد کنید");
    }

    if (isNaN(Phone)) {
      setIsLoading(false);
      return toast.error("لطفا شماره موبایل صحیح را وارد کنید");
    }

    if (Password !== PasswordConfirm) {
      setIsLoading(false);
      return toast.error("رمز عبور با تکرار آن همخوانی ندارد");
    }

    const data = {
      name: Name,
      phone: Phone,
      birthday: {
        year: Year,
        month: Month,
        day: Day,
      },
      pass: Password,
    };

    let response;
    try {
      response = await signup(data);
    } catch (error) {
      toast.error(error);
      setIsLoading(false);
      return;
    }
    setIsLoading(false);

    navigate("/dashboard");
  }

  return (
    <div className="log_sign-background">
      <div className="log_sign-container">
        <Link to="/">
          <div className="close-button popup-mode-close">
            <FontAwesomeIcon icon={faArrowLeft} />
          </div>
        </Link>
        <div className="log_sign-popup sign-popup">
          <form action="" className="log_sign-form" onSubmit={handleSubmit}>
            <div className="goto-login">
              <Link to="/login">قبلا ثبت نام کرده ام ...</Link>
            </div>
            <InputBox
              name="sign-name"
              label="نام و نام خانوادگی"
              type="text"
              gap="35px"
              ref={nameRef}
            />
            <InputBox
              name="sign-tel"
              label="شماره موبایل"
              type="text"
              gap="35px"
              ref={phoneRef}
            />
            <DateSelector
              gap="35px"
              ref={{
                dRef: dayRef,
                mRef: monthRef,
                yRef: yearRef,
              }}
            />
            <InputBox
              name="sign-pass"
              label="رمز عبور"
              type="password"
              gap="35px"
              ref={passRef}
            />
            <InputBox
              name="sign-pass-confirm"
              label="تکرار رمز عبور"
              type="password"
              gap="35px"
              ref={passConfRef}
            />

            <button
              className="log_sign-button red-submit-btn"
              disabled={isLoading}
            >
              {isLoading ? (
                <Loader loading={isLoading} small dark />
              ) : (
                "ثبت نام"
              )}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
